// Decision 65 (Block J): which occurrences of a repeating task an edit changes. Opened over the
// task form when the task being edited is one occurrence of a series (utils/recurringEdit.js).
// Carla's decision 2 (2026-10-12): "Only this occurrence" is offered (first, and chosen unless the
// person picks another: it changes the least), and with action="delete" the same question is asked
// before deleting from an occurrence: only this one, or every occurrence.
// UI-24 item 25 (Carla, 2026-10-20): with Repeat turned off (repeatOff), the occurrence being edited
// becomes the single task on its own date and time, and earlier occurrences stay as history; this
// and following, or all, do the same, and only this one cannot change how a task repeats, so it is
// not offered. The dialog says so.
import React, { useEffect, useState } from 'react';
import { Button, Modal, RadioGroup } from '../ui';
import { SERIES_SCOPES, DELETE_SCOPES } from '../utils/recurringEdit';

export const REPEAT_OFF_NOTE = 'Repeat is off, so this occurrence becomes a single task on its own date and time. Earlier occurrences stay in your history.';

export default function RecurringEditDialog({ open, onClose, onChoose, action = 'edit', repeatOff = false }) {
  const deleting = action === 'delete';
  const stopping = !deleting && repeatOff;
  const first = stopping ? 'following' : 'this';
  const [scope, setScope] = useState(first);
  useEffect(() => { if (open) setScope(first); }, [open, first]);
  return (
    <Modal open={open} onClose={onClose} title={deleting ? 'Delete a repeating task' : 'Change a repeating task'} color="pastel-yellow" width={460}
      footer={<>
        <Button variant="tertiary" onClick={onClose}>{deleting ? 'Cancel' : 'Back to the task'}</Button>
        {deleting
          ? <Button variant="delete" onClick={() => onChoose(scope)} data-testid="recurring-delete-confirm">Delete</Button>
          : <Button variant="confirm" onClick={() => onChoose(scope)} data-testid="recurring-edit-save">Save changes</Button>}
      </>}>
      {stopping && <p className="ui-field__hint" data-testid="recurring-repeat-off-note">{REPEAT_OFF_NOTE}</p>}
      <RadioGroup
        label={deleting ? 'Which occurrences should be deleted?' : 'Which occurrences should change?'}
        name={deleting ? 'recurring-delete-scope' : 'recurring-edit-scope'}
        options={deleting ? DELETE_SCOPES : stopping ? SERIES_SCOPES.filter((o) => o.value !== 'this') : SERIES_SCOPES}
        value={scope}
        onChange={setScope}
      />
    </Modal>
  );
}
